export default "__VITE_ASSET__EavjMmNt__"